<script lang="ts">
  import Button from '$components/elements/Button.svelte';
  import Desktop from '$components/utils/Desktop.svelte';
  import Image from '$components/utils/Image.svelte';
  import Mobile from '$components/utils/Mobile.svelte';
  import Text from '$components/utils/Text.svelte';
</script>

<div class="advantages-block">
  <Desktop>
    <Image
      key="page.club.benefits"
      thumb="1150x1500"
      borderRadius="13px 0px 0px 13px"
      width="45%"
    />
  </Desktop>
  <Mobile>
    <Image
      key="page.club.benefits"
      thumb="1150x1500"
      borderRadius="13px 13px 0px 0px"
      width="100%"
      height="256px"
    />
  </Mobile>
  <div class="advantages-block__content">
    <div class="advantages-block__content__text">
      <h1>
        <Text key="page.club.advantages.heading" />
      </h1>
      <ul>
        <li><Text key="page.club.advantages.list.1" /></li>
        <li><Text key="page.club.advantages.list.2" /></li>
        <li><Text key="page.club.advantages.list.3" /></li>
        <li><Text key="page.club.advantages.list.4" /></li>
        <li><Text key="page.club.advantages.list.5" /></li>
        <li><Text key="page.club.advantages.list.6" /></li>
      </ul>
    </div>
    <div class="advantages-block__content__button">
      <Button type="spacious" icon="arrow-right" iconColor="#fff" href="/klub-bible21/registrace">
        <Text key="page.club.advantages.button" />
      </Button>
    </div>
  </div>
</div>

<style lang="scss">
  .advantages-block {
    max-width: 1280px;
    width: 80%;

    display: flex;
    flex-direction: row;

    margin-bottom: 143px;
    margin-top: 80px;

    align-self: center;

    background-color: $color-white;
    border: 1.5px solid rgba($color-medium-gray, 0.8);
    border-radius: 13px;

    &__content {
      display: flex;
      flex-direction: column;
      width: 40%;

      margin-left: auto;
      margin-right: auto;
      margin-top: 63px;
      margin-bottom: 84px;

      &__text {
        display: flex;
        flex-direction: column;

        h1 {
          font-weight: 700;
          font-size: 36px;
          line-height: 45px;
        }

        ul {
          margin-top: 45px;
          margin-bottom: 38px;
          li {
            font-weight: 500;
            font-size: 17px;
            line-height: 34px;
          }
        }
      }

      &__button {
        padding-top: 38px;
      }
    }
  }

  @include mobile {
    .advantages-block {
      flex-direction: column;
      width: 90%;

      &__content {
        width: 100%;

        margin-top: 20px;
        margin-bottom: 0;

        &__text {
          width: 90%;

          display: flex;
          margin-left: auto;
          margin-right: auto;

          h1 {
            font-weight: 700;
            font-size: 24px;
            line-height: 160%;
          }

          ul {
            li {
              margin-top: 20px;
              margin-bottom: 20px;

              font-weight: 500;
              font-size: 17px;
              line-height: 28px;
            }
          }
        }
        &__button {
          background-color: $color-medium-gray;
          width: 100%;

          display: flex;
          justify-content: center;

          padding-top: 30px;
          padding-bottom: 30px;

          background: $color-medium-gray;
          border-radius: 0px 0px 13px 13px;
        }
      }
    }
  }
</style>
